import * as types from '../constants/templatedetails'

const initialState = {
  Status: null,
  apiGetResult: null,
  apiPostResult: null,
  templatedetails: null,
  templatedetailsList: null
}

export function templateDetails(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_TEMPLATE_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_TEMPLATE_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        templatedetails: action.data
      };
    case types.FETCH_TEMPLATE_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false,
        // templatedetailsList:action.error
      };
    case types.FETCH_TEMPLATE_RESET:
      return {
        ...state,
        Status: null,
        apiGetResult: null,
        templatedetailsList: null,
        templatedetails: null,
      };
    case types.FETCH_TEMPLATE_LIST_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_TEMPLATE_LIST_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        templatedetailsList: action.data
      };
    case types.FETCH_TEMPLATE_LIST_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false,
        // templatedetailsList:action.error
      };    
    case types.EDIT_TEMPLATE_RESET:
      return {
        ...initialState,
        Status: null,
        apiPostResult: null
      };
    case types.EDIT_TEMPLATE_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.EDIT_TEMPLATE_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true
      };
    case types.EDIT_TEMPLATE_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false
      };
    default:
      return state;
  }
} 


// WEBPACK FOOTER //
// ./reducers/templatedetails.js